module.exports = __webpack_public_path__ + "img/terroir-1.081d453f.jpg";